import { Alert, Box, Button, Paper, TextField, Typography } from '@mui/material';
import { navigate } from '@reach/router';
import React, { useState } from 'react';
import apiClient from '../api/client';
import Layout from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
  });

  const { login, register, refreshAuth } = useAuth();

  // Обработка токенов, пришедших из OAuth callback как query-параметры
  React.useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        const url = new URL(window.location.href);
        const at = url.searchParams.get('access_token');
        const rt = url.searchParams.get('refresh_token');
        const isNew = url.searchParams.get('new') === '1';
        if (at) {
          localStorage.setItem('access_token', at);
          if (rt) localStorage.setItem('refresh_token', rt);
          // Чистим query
          url.searchParams.delete('access_token');
          url.searchParams.delete('refresh_token');
          url.searchParams.delete('new');
          window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);

          // Загружаем пользователя сразу после сохранения токенов
          await refreshAuth();

          // Редирект: новые — в организации, существующие — в дашборд
          navigate(isNew ? '/organizations' : '/dashboard');
        }
      } catch (e) {
        console.error('OAuth callback error:', e);
      }
    };

    handleOAuthCallback();
  }, [refreshAuth]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (isLogin) {
        const success = await login(formData.email, formData.password);
        if (success) {
          navigate('/dashboard');
        } else {
          setError('Неверный email или пароль');
        }
      } else {
        const success = await register(formData);
        if (success) {
          navigate('/organizations');
        } else {
          setError('Ошибка при регистрации');
        }
      }
    } catch (error) {
      setError('Произошла ошибка. Пожалуйста, попробуйте позже.');
    }
  };

  return (
    <Layout>
      <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
        <Paper elevation={3} sx={{ p: 3 }}>
          <Typography variant="h5" component="h1" gutterBottom>
            {isLogin ? 'Вход' : 'Регистрация'}
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Пароль"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              margin="normal"
              required
            />
            {!isLogin && (
              <>
                <TextField
                  fullWidth
                  label="Имя"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  margin="normal"
                  required
                />
              </>
            )}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2 }}
            >
              {isLogin ? 'Войти' : 'Зарегистрироваться'}
            </Button>
            <Button
              onClick={() => setIsLogin(!isLogin)}
              fullWidth
              sx={{ mt: 1 }}
            >
              {isLogin ? 'Нет аккаунта? Зарегистрироваться' : 'Уже есть аккаунт? Войти'}
            </Button>
          </form>
          <Button
            fullWidth
            sx={{ mt: 1 }}
            variant="outlined"
            onClick={() => {
              const base = apiClient.defaults?.baseURL || 'http://127.0.0.1:5000';
              const redirect = encodeURIComponent(window.location.origin + '/auth');
              window.location.href = `${base}/auth/oauth/authorize?scope=openid%20profile%20email&state=crm&redirect=${redirect}`;
            }}
          >
            Войти через GoSphere
          </Button>
        </Paper>
      </Box>
    </Layout>
  );
};

export default AuthPage; 